import { render, staticRenderFns } from "./DividerWrapper.form.vue?vue&type=template&id=a0db58ea&scoped=true&"
import script from "./DividerWrapper.form.vue?vue&type=script&lang=js&"
export * from "./DividerWrapper.form.vue?vue&type=script&lang=js&"
import style0 from "./DividerWrapper.form.vue?vue&type=style&index=0&id=a0db58ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0db58ea",
  null
  
)

export default component.exports